module.exports = __webpack_public_path__ + "assets/icon-pendant-question-c1688ced.png";